module.exports = __webpack_public_path__ + "img/final_3.9191d355.png";